import { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import ReactApexChart from "react-apexcharts";
import { ReactComponent as VideoIcon } from "../../../assets/icons/VideoIcon.svg";
import { ReactComponent as UserTotalIcon } from "../../../assets/icons/UserSideBarIcon.svg";
import { ReactComponent as TotalChannelIcon } from "../../../assets/icons/ChannelIcon.svg";
import { ReactComponent as TotalShortsIcon } from "../../../assets/icons/ShortIcon.svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { connect, useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../store/admin/admin.action";
import {
  getDashboardCount,
  getDashboardUserChart,
  getChartAnalyticOfActiveUser,
  getAdminEarningChart,
  getRecentMonetizationRequests,
  getRecentWithdrawRequests,
} from "../../store/dashboard/dashboard.action";
import {
  IconBrandYoutube,
  IconMovie,
  IconUser,
  IconVideo,
  IconCash,
  IconCashBanknote,
  IconReport,
  IconWallet,
  IconCoin,
  IconPremiumRights,
  IconAd,
  IconUsers,
  IconChartAreaLine,
} from "@tabler/icons-react";
import { Skeleton } from "@mui/material";
import Table from "../../extra/Table";
import LazyImage from "../../../common/ImageFallback";
import UniqueIdCopy from "../../extra/UniqueIdCopy";

const ChartEmptyState = ({ title, height = 300, message }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-center px-3"
    style={{ height, minHeight: 280 }}
  >
    <p className="mb-3 text-muted" style={{ fontSize: 15 }}>
      {title}
    </p>
    <div
      className="d-flex align-items-center justify-content-center mb-3"
      style={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "rgba(255, 94, 117, 0.12)",
      }}
    >
      <IconChartAreaLine size={26} color="#ff5e75" stroke={1.6} />
    </div>
    <h6 className="fw-semibold mb-1" style={{ color: "#1f2937" }}>
      No {title} Found
    </h6>
    <p className="mb-0 text-muted" style={{ fontSize: 13, maxWidth: 280 }}>
      {message ||
        "Data will appear here once available. Try changing the date range."}
    </p>
  </div>
);

const Dashboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const {
    dashboardCount,
    chartAnalyticOfVideos,
    chartAnalyticOfShorts,
    chartAnalyticOfUsers,
    chartAnalyticOfActiveUser,
    adminEarningChart,
    recentMonetizationRequests,
    recentWithdrawRequests,
  } = useSelector((state) => state.dashboard);
  const { isLoading } = useSelector((state) => state.dialogue);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let label = [];
  let data = [];
  let dataVideo = [];
  let dataUser = [];
  let dataShort = [];
  let dataCount = [];

  const startDateFormat = (startDate) => {
    if (startDate === "All") return "All";
    return dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : dayjs().subtract(7, "day").format("YYYY-MM-DD");
  };

  const endDateFormat = (endDate) => {
    if (endDate === "All") return "All";
    return dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
  };
  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getDashboardCount(startDateData, endDateData));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashboardUserChart(startDateData, endDateData, "Short"));
  }, [dispatch, startDate, endDate]);
  useEffect(() => {
    dispatch(getDashboardUserChart(startDateData, endDateData, "Video"));
  }, [dispatch, startDate, endDate]);
  useEffect(() => {
    dispatch(getDashboardUserChart(startDateData, endDateData, "User"));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getChartAnalyticOfActiveUser(startDateData, endDateData));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getAdminEarningChart(startDateData, endDateData));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getRecentMonetizationRequests());
    dispatch(getRecentWithdrawRequests());
  }, [dispatch]);

  // Process users' data
  chartAnalyticOfUsers?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    dataUser.push(data_?.count || 0); // Use 0 if count is undefined
  });

  chartAnalyticOfVideos?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    dataVideo.push(data_?.count || 0); // Use 0 if count is undefined
  });

  // Process shorts' data
  chartAnalyticOfShorts?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    dataShort.push(data_?.count || 0); // Use 0 if count is undefined
  });

  let labelSet = new Set(label);
  // Convert labelSet back to array and sort
  label = [...labelSet].sort((a, b) => new Date(a) - new Date(b));

  // Ensure all arrays have the same length and are aligned properly with labels
  const maxLength = label?.length;

  for (let i = 0; i < maxLength; i++) {
    if (dataUser[i] === undefined) {
      dataUser[i] = 0;
    }
    if (dataVideo[i] === undefined) {
      dataVideo[i] = 0;
    }
    if (dataShort[i] === undefined) {
      dataShort[i] = 0;
    }
  }
  var webSize = $(window).width();
  const resHeight =
    webSize >= 992 ? 500 : webSize < 992 && webSize > 576 ? 400 : 300;
  const resWidth = webSize < 576 ? 300 : 450;

  const totalSeries = {
    labels: label,
    dataSet: [
      {
        name: "Total User",
        data: dataUser,
      },
      {
        name: "Total Video",
        data: dataVideo,
      },
      {
        name: "Total Short",
        data: dataShort,
      },
    ],
  };

  const optionsTotal = {
    chart: {
      type: "area",
      stacked: false,
      height: "200px",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      categories: label,
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4, // Adjust the offset vertically
        fontSize: 10,
      },
    },

    tooltip: {
      shared: true,
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#FD4D66", "#786D81", "#e91e63"],
  };

  // const activeUserData = chartAnalyticOfActiveUser?.reduce(function (acc, obj) {
  //   return acc + obj?.count;
  // }, 0);
  // const userData = chartAnalyticOfUsers?.reduce(function (acc, obj) {
  //   return acc + obj?.count;
  // }, 0);
  // const percentage = (activeUserData / userData) * 100;
  // const seriesGradient = [percentage ? percentage?.toFixed(0) : "0"];

  const activePercentageofUser = chartAnalyticOfActiveUser?.activeUsers
    ? (chartAnalyticOfActiveUser?.activeUsers /
        chartAnalyticOfActiveUser?.totalUsers) *
      100
    : 0;
  const blockPercentageofUser = chartAnalyticOfActiveUser?.blockedUsers
    ? (chartAnalyticOfActiveUser?.blockedUsers /
        chartAnalyticOfActiveUser?.totalUsers) *
      100
    : 0;
  const seriesGradient = [activePercentageofUser, blockPercentageofUser];

  const optionsGradient = {
    chart: {
      height: 400,
      width: 200,
      type: "radialBar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 365,
        hollow: {
          margin: 0,
          size: "55%",
          background: "#fff",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: false,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
        },
        track: {
          background: "#dfdfdfef", // Change the background color here
          strokeWidth: "100%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: false,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontFamily: undefined,
            fontWeight: 700,
            fontSize: "17px",
            color: "#404040",
            offsetY: -10,
          },
          value: {
            formatter: function (val) {
              return parseInt(val) + "%";
            },
            color: "#ff5e75",
            fontWeight: 600,
            fontSize: "30px",
            show: true,
          },
        },
      },
    },
    labels: ["Active Users" , "Blocked Users"],
    fill: {
      type: "solid",
      colors: ["#ff5e75" , "#786d81"],
    },
    stroke: {
      lineCap: "round",
    },
    states: {
      hover: {
        filter: {
          type: "none", // Disables the hover effect
        },
      },
    },
  };

  const sortedEarningChart = [...(adminEarningChart || [])].sort(
    (a, b) => new Date(a?._id) - new Date(b?._id)
  );
  const earningLabels = sortedEarningChart.map((item) => item?._id);
  const earningSeries = [
    {
      name: "Coin Plan Earning",
      data: sortedEarningChart.map((item) => item?.coinPlanEarning || 0),
    },
    {
      name: "Premium Plan Earning",
      data: sortedEarningChart.map((item) => item?.premiumPlanEarning || 0),
    },
    {
      name: "Total Earning",
      data: sortedEarningChart.map((item) => item?.totalEarning || 0),
    },
  ];

  const hasAnalyticsData = label?.length > 0;
  const hasEarningData = sortedEarningChart?.length > 0;
  const hasUserActivityData = !!chartAnalyticOfActiveUser?.totalUsers;

  const optionsEarning = {
    chart: {
      type: "area",
      stacked: false,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: true,
      labels: {
        formatter: function (val) {
          return Math.round(val);
        },
      },
    },
    xaxis: {
      categories: earningLabels,
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4,
        fontSize: 10,
      },
    },
    tooltip: {
      shared: true,
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#786D81", "#FD4D66", "#e91e63"],
  };

  const getRequestStatus = (status) => {
    if (status === 1) return { label: "Pending", className: "text-warning" };
    if (status === 2) return { label: "Accepted", className: "text-success" };
    if (status === 3) return { label: "Declined", className: "text-danger" };
    return { label: "-", className: "" };
  };

  const monetizationTableMap = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => <span className="text-nowrap">{index + 1}</span>,
    },
    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center">
          <LazyImage imageSrc={row?.user?.image} width="40px" height="40px" />
          <div className="ms-3 text-start">
            <div className="fw-semibold text-capitalize">
              {row?.user?.fullName || "-"}
            </div>
            <div className="text-muted small text-capitalize">
              {row?.user?.nickName || "-"}
            </div>
            <UniqueIdCopy value={row?.user?.uniqueId} placeholder="-" />
          </div>
        </div>
      ),
    },
    {
      Header: "CHANNEL",
      body: "channelName",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.channelName || "-"}</span>
      ),
    },
    {
      Header: "MIN SUBSCRIBERS",
      body: "minSubScriber",
      Cell: ({ row }) => <span>{row?.minSubScriber ?? 0}</span>,
    },
    {
      Header: "MIN WATCH TIME (HOURS)",
      body: "minWatchTime",
      Cell: ({ row }) => <span>{row?.minWatchTime ?? 0}</span>,
    },
    {
      Header: "TOTAL SUBSCRIBERS",
      body: "totalSubScribers",
      Cell: ({ row }) => <span>{row?.totalSubScribers ?? 0}</span>,
    },
    {
      Header: "TOTAL WATCH TIME (MINUTES)",
      body: "totalWatchTime",
      Cell: ({ row }) => <span>{row?.totalWatchTime ?? 0}</span>,
    },
    {
      Header: "TOTAL WATCH TIME (HOURS)",
      body: "totalWatchTimeInHours",
      Cell: ({ row }) => <span>{row?.totalWatchTimeInHours ?? 0}</span>,
    },
    {
      Header: "DATE",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-nowrap">
          {row?.createdAt
            ? dayjs(row.createdAt).format("MM/DD/YYYY hh:mm A")
            : "-"}
        </span>
      ),
    },
    {
      Header: "STATUS",
      body: "status",
      Cell: ({ row }) => {
        const statusInfo = getRequestStatus(row?.status);
        return (
          <div className={`action-button ${statusInfo.className}`}>
            {statusInfo.label}
          </div>
        );
      },
    },
  ];

  const withdrawTableMap = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => <span className="text-nowrap">{index + 1}</span>,
    },
    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center">
          <LazyImage imageSrc={row?.user?.image} width="40px" height="40px" />
          <div className="ms-3 text-start">
            <div className="fw-semibold text-capitalize">
              {row?.user?.fullName || "-"}
            </div>
            <div className="text-muted small text-capitalize">
              {row?.user?.nickName || "-"}
            </div>
            <UniqueIdCopy value={row?.user?.uniqueId} placeholder="-" />
          </div>
        </div>
      ),
    },
    {
      Header: "CHANNEL",
      body: "channelName",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.channelName || "-"}</span>
      ),
    },
    {
      Header: "TRANSACTION ID",
      body: "uniqueId",
      Cell: ({ row }) => (
        <UniqueIdCopy value={row?.uniqueId} placeholder="-" />
      ),
    },
    {
      Header: "AMOUNT",
      body: "requestAmount",
      Cell: ({ row }) => <span>{row?.requestAmount ?? 0}</span>,
    },
    {
      Header: "GATEWAY",
      body: "paymentGateway",
      Cell: ({ row }) => <span>{row?.paymentGateway || "-"}</span>,
    },
    {
      Header: "PAYMENT DETAILS",
      body: "paymentDetails",
      Cell: ({ row }) => (
        <div className="text-start">
          {row?.paymentDetails?.length > 0 ? (
            row.paymentDetails.map((item, index) => (
              <div key={index} className="text-nowrap small">
                {item}
              </div>
            ))
          ) : (
            <span>-</span>
          )}
        </div>
      ),
    },
    {
      Header: "DATE",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-nowrap">
          {row?.createdAt
            ? dayjs(row.createdAt).format("MM/DD/YYYY hh:mm A")
            : "-"}
        </span>
      ),
    },
    {
      Header: "STATUS",
      body: "status",
      Cell: ({ row }) => {
        const statusInfo = getRequestStatus(row?.status);
        return (
          <div className={`action-button ${statusInfo.className}`}>
            {statusInfo.label}
          </div>
        );
      },
    },
  ];

  const CustomeCard = ({ link, title, count, Icon }) => {
    return (
      <div
        className={`col-xl-3 col-sm-6 col-12 ${link ? "cursor-pointer" : ""}`}
        onClick={() => link && navigate(link)}
      >
        <div className="card">
          {isLoading ? (
            <Skeleton variant="square" width="100%" height="135px" style={{ borderRadius: '15px' }} />
          ) : (
            <div className={`card-content ${link ? "cursor-pointer" : ""}`}>
              <div className="card-body p-4">
                <div className="align-content-center d-flex justify-content-between media">
                  <div className="media-body text-left">
                    <h3 className="warning">{count ?? "0"}</h3>
                    <span className="fw-medium">{title}</span>
                  </div>
                  <div className="align-self-center">
                    {<Icon className={"dashboard-card-icon"} />}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="dashboard " style={{marginTop: "0px" }}>
        <div className="dashboardHeader primeHeader !mb-0 !p-0">
          <h4 className="heading-dashboard fw-semibold d-block">
            Welcome Admin !
          </h4>
          <NewTitle
            dayAnalyticsShow={true}
            titleShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            name={`Dashboard`}
          />
        </div>
        <div className="dashBoardMain px-2 mt-4">
          <div className="row dashboard-count-box">
            <CustomeCard
              link={"/admin/userTable"}
              title={"Total Users"}
              count={dashboardCount?.totalUsers}
              Icon={IconUser}
            />
            <CustomeCard
              link={"/admin/channel"}
              title={"Total Channels"}
              count={dashboardCount?.totalChannels}
              Icon={IconBrandYoutube}
            />
            <CustomeCard
              link={"/admin/videos"}
              title={"Total Videos"}
              count={dashboardCount?.totalVideos}
              Icon={IconVideo}
            />
            <CustomeCard
              link={"/admin/shorts"}
              title={"Total Shorts"}
              count={dashboardCount?.totalShorts}
              Icon={IconMovie}
            />
            <CustomeCard
              link={"/admin/withdrawRequest"}
              title={"Pending Withdraws"}
              count={dashboardCount?.pendingWithdraws}
              Icon={IconCash}
            />
            <CustomeCard
              link={"/admin/allmonetizationRequest"}
              title={"Pending Monetization"}
              count={dashboardCount?.pendingMonetization}
              Icon={IconCashBanknote}
            />
            <CustomeCard
              link={"/admin/allreport"}
              title={"Total Reports"}
              count={dashboardCount?.totalReports}
              Icon={IconReport}
            />
            <CustomeCard
              link={"/admin/adminEarnings"}
              title={"Total Earnings"}
              count={dashboardCount?.totalEarnings}
              Icon={IconWallet}
            />
            <CustomeCard
              link={"/admin/adminEarnings"}
              title={"Coin Plan Earnings"}
              count={dashboardCount?.coinPlanEarnings}
              Icon={IconCoin}
            />
            <CustomeCard
              link={"/admin/adminEarnings"}
              title={"Premium Plan Earnings"}
              count={dashboardCount?.premiumPlanEarnings}
              Icon={IconPremiumRights}
            />
            <CustomeCard
              title={"Total Advertisements"}
              count={dashboardCount?.totalAdvertisements}
              Icon={IconAd}
            />
            <CustomeCard
              link={"/admin/premiumPlanTable"}
              title={"Total Subscriptions"}
              count={dashboardCount?.totalSubscriptions}
              Icon={IconUsers}
            />
          </div>
          <div className="dashboard-analytics">
            <h6 className="">Data Analytics</h6>
            <div className="row dashboard-chart justify-content-between">
              <div
                className="col-lg-9 col-md-12 col-sm-12 mt-lg-0 mt-4 dashboard-chart-box"
                style={{ position: "relative" }}
              >
                <div
                  id="chart"
                  className="dashboard-user-count"
                  style={{ height: "100%" }}
                >
                  <div className="date-range-picker mb-2 pb-2"></div>
                  <div className="">
                    {isLoading ? (
                      <Skeleton variant="rectangular" width="100%" height={resHeight} style={{ borderRadius: '15px' }} />
                    ) : hasAnalyticsData ? (
                      <ReactApexChart
                        options={optionsTotal}
                        series={
                          totalSeries.dataSet.length >= 1
                            ? totalSeries.dataSet
                            : ""
                        }
                        type="area"
                        height={resHeight}
                      />
                    ) : (
                      <ChartEmptyState title="Analytics Data" height={resHeight} />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-12  col-sm-12 mt-3 mt-lg-0 dashboard-total-user">
                <div className="user-activity">
                  <div className="border-bottom p-3">
                    <h6 className="m-0">Total User Activity</h6>
                  </div>
                  <div
                    id="chart"
                    style={{ display: "flex", justifyContent: "center" }}
                    className="p-3"
                  >
                    {isLoading ? (
                      <Skeleton variant="circular" width={resWidth - 100} height={resWidth - 100} />
                    ) : hasUserActivityData ? (
                      <ReactApexChart
                        options={optionsGradient}
                        series={seriesGradient}
                        type="radialBar"
                        width={resWidth}
                        height={resWidth === 300 ? 300 : 360}
                      />
                    ) : (
                      <ChartEmptyState
                        title="User Activity"
                        height={resWidth === 300 ? 300 : 360}
                        message="User activity will appear here once available."
                      />
                    )}
                  </div>
                  {hasUserActivityData && (
                  <div className="p-3">
                    <div className="total-user-chart">
                      <span></span>
                      <h5>Total Active User</h5>
                    </div>
                    <div className="total-active-chart">
                      <span></span>
                      <h5>Total Block User</h5>
                    </div>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="dashboard-analytics mt-4">
            <h6 className="">Admin Earning Analytics</h6>
            <div className="row dashboard-chart">
              <div
                className="col-12 mt-lg-0 mt-4 dashboard-chart-box"
                style={{ position: "relative" }}
              >
                {isLoading ? (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={resHeight}
                    style={{ borderRadius: "15px" }}
                  />
                ) : hasEarningData ? (
                  <ReactApexChart
                    options={optionsEarning}
                    series={earningSeries}
                    type="area"
                    height={resHeight}
                  />
                ) : (
                  <ChartEmptyState title="Earning Data" height={resHeight} />
                )}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 mb-4">
              <div className="user-table real-user mb-3">
                <div className="user-table-top">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5
                      style={{
                        fontWeight: "500",
                        fontSize: "20px",
                        marginTop: "5px",
                        marginBottom: "4px",
                      }}
                    >
                      Recent Monetization Requests
                    </h5>
                    <span
                      className="cursor-pointer text-secondary fw-medium"
                      onClick={() => navigate("/admin/allmonetizationRequest")}
                    >
                      View All
                    </span>
                  </div>
                </div>
                <Table
                  data={recentMonetizationRequests || []}
                  mapData={monetizationTableMap}
                  PerPage={recentMonetizationRequests?.length || 10}
                  Page={1}
                  type={"server"}
                  loading={isLoading}
                />
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="user-table real-user mb-3">
                <div className="user-table-top">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5
                      style={{
                        fontWeight: "500",
                        fontSize: "20px",
                        marginTop: "5px",
                        marginBottom: "4px",
                      }}
                    >
                      Recent Withdraw Requests
                    </h5>
                    <span
                      className="cursor-pointer text-secondary fw-medium"
                      onClick={() => navigate("/admin/withdrawRequest")}
                    >
                      View All
                    </span>
                  </div>
                </div>
                <Table
                  data={recentWithdrawRequests || []}
                  mapData={withdrawTableMap}
                  PerPage={recentWithdrawRequests?.length || 10}
                  Page={1}
                  type={"server"}
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getProfile,
  getDashboardCount,
  getDashboardUserChart,
  getChartAnalyticOfActiveUser,
  getAdminEarningChart,
  getRecentMonetizationRequests,
  getRecentWithdrawRequests,
})(Dashboard);
